import * as R from 'ramda';


export default function DeleteWorkstationsDialogController(
  $rootScope,
  $scope,
  $q,
  alerts,
  bcpDataService,
  ssDialogService,
  confirmDialog
) {
  const vm = this;
  
  vm.deleteIsSelected = false;
  vm.hasData = true;

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleDelete = _handleDelete;
  vm.handleSelectAll = _handleSelectAll;
  vm.handleSelectOne = _handleSelectOne;

  /** ************************************************
   * Event Handlers
   */
  activate();

  function activate() {
  }

  function _handleCloseDialog() {
    ssDialogService.hide(ssDialogService.dialogs.bcp.deleteWorkstationsDialog);
  }

  function _handleSelectAll() {
    R.forEach((workstation) => {
      workstation.isSelected = vm.selectAll;
      vm.deleteIsSelected = vm.selectAll;
    }, vm.workstations);
  }

  function _handleSelectOne() {
    let itemDeleteIsSelected = false;
    
    R.forEach((workstation) => {
      if (workstation.isSelected) {
        itemDeleteIsSelected = true;
      }
    }, vm.workstations);

    vm.deleteIsSelected = itemDeleteIsSelected
  }

  function _handleDelete($event) {
    ssDialogService.dialogs.bcp.confirmDeleteWorkstationsDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Delete Workstations?',
        message: `Are you sure you want to delete the selected Workstations?`,
        handleYesClick() {
          _handleConfirmDelete();
        },
        handleNoClick: _handleCancelDelete,
      })
    );
    ssDialogService.show(ssDialogService.dialogs.bcp.confirmDeleteWorkstationsDialog);
  }

  function _handleConfirmDelete(workstation) {
    const _ids = [];

    R.forEach((workstation) => {
      if (workstation.isSelected) {
        _ids.push(workstation.assessmentWorkstationId);
      }
    }, vm.workstations);
    
    const idList = {};
    idList.ids = _ids;

    return bcpDataService.deleteWorkstations(idList).then(() => {
      alerts.success('The selected Workstation(s) have been deleted successfully.');
      $rootScope.$broadcast('setDocumentRegenerateFlag');
      $rootScope.$broadcast('refreshBCPWorkstations');
      _closeDeleteDialog();
      _handleCloseDialog();
    })
    .catch(() => {
      alerts.error('An error occurred deleting the selected Workstation(s).');
    });
  }

  function _handleCancelDelete() {
    _closeDeleteDialog();
  }

  function _closeDeleteDialog() {
    ssDialogService.hide(ssDialogService.dialogs.bcp.confirmDeleteWorkstationsDialog);
  }
}

DeleteWorkstationsDialogController.$inject = [
  '$rootScope',
  '$scope',
  '$q',
  'alerts',
  'bcpDataService',
  'ssDialogService',
  'confirmDialog',
];
